import { authSessionSchema, type AuthSession } from "../schemes";

let state: AuthSession | null = null;

const TOKEN_STORAGE_KEY = "token";
const USER_STORAGE_KEY = "user";

const readStoredSession = (): AuthSession | null => {
	if (typeof window === "undefined") {
		return null;
	}

	const token = window.localStorage.getItem(TOKEN_STORAGE_KEY);
	const rawUser = window.localStorage.getItem(USER_STORAGE_KEY);

	if (!token || !rawUser) {
		return null;
	}

	try {
		const user = JSON.parse(rawUser);
		const parsed = authSessionSchema.safeParse({ token, user });

		if (!parsed.success) {
			return null;
		}

		return parsed.data;
	} catch {
		return null;
	}
};

const persistSession = (session: AuthSession) => {
	if (typeof window === "undefined") {
		return;
	}

	window.localStorage.setItem(TOKEN_STORAGE_KEY, session.token);
	window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(session.user));
};

const getSession = (): AuthSession | null => {
	if (state) {
		return state;
	}

	const storedSession = readStoredSession();
	if (!storedSession) {
		return null;
	}

	state = storedSession;
	return state;
};

/**
 * Check if the user has a session.
 */
export const hasSession = () => getSession() !== null;

export const getToken = () => getSession()?.token;

export const getUser = () => getSession()?.user;

export const setSession = (session: AuthSession) => {
	state = session;
	persistSession(session);
};

export const clearSession = () => {
	state = null;

	if (typeof window === "undefined") {
		return;
	}

	window.localStorage.removeItem(TOKEN_STORAGE_KEY);
	window.localStorage.removeItem(USER_STORAGE_KEY);
};
